import { render } from "./BaseMonthSelector.vue?vue&type=template&id=6811b449&scoped=true"
import script from "./BaseMonthSelector.vue?vue&type=script&lang=js"
export * from "./BaseMonthSelector.vue?vue&type=script&lang=js"

import "./BaseMonthSelector.vue?vue&type=style&index=0&id=6811b449&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6811b449"]])

export default __exports__